// web-rnw twin of ./learnedRestStore.ts: localStorage instead of AsyncStorage.
import { createLearnedRestStore } from './learnedRestCore';

const KEY = 'jackedlogs.timers.v1.learnedRest';

export const learnedRest = createLearnedRestStore({
  get: async () => {
    try {
      return localStorage.getItem(KEY);
    } catch {
      return null;
    }
  },
  set: async (v) => {
    localStorage.setItem(KEY, v);
  },
});
